// extracted by mini-css-extract-plugin
export default {"wrapper":"DetailBlock_wrapper__dCzK+","label":"DetailBlock_label__VPfUH","value":"DetailBlock_value__BwWWX"};